import Vue from "vue";
import Router from "vue-router";
import index from "@/components/index";


import canguanxuzhi from "@/components/right_nav/canguanxuzhi";
import yellow from "@/components/index_parent/yellow";


import foot from "@/components/foot";
import page2 from "@/components/demon/page2";

Vue.use(Router);

export default new Router({
  // mode: "history",
  routes: [
    {
      path: "/enApp",
      name: "enApp",

      redirect: "Home",
      component: () =>
        import(
          /*
        webpackChunkName:"enApp" */ "../components/English/enApp.vue"
        ),

      children: [
        {
          path: "About",
          name: "About",
          component: () =>
            import(
              /*
      webpackChunkName:"About" */ "../components/English/About.vue"
            )
        },
        {
          path: "Collection",
          name: "Collection",
          component: () =>
            import(
              /*
      webpackChunkName:"zhengji" */ "../components/English/Collection.vue"
            )
        },
        {
          path: "Exhibition",
          name: "Exhibition",
          component: () =>
            import(
              /*
      webpackChunkName:"zhengji" */ "../components/English/Exhibition.vue"
            )
        },
        {
          path: "Guide",
          name: "Guide",
          component: () =>
            import(
              /*
      webpackChunkName:"zhengji" */ "../components/English/Guide.vue"
            )
        },
        {
          path: "Home",
          name: "Home",
          component: () =>
            import(
              /*
      webpackChunkName:"zhengji" */ "../components/English/Home.vue"
            )
        }
      ]
    },

    {
      path: "/enfoot",
      name: "enfoot",
      component: () =>
        import(
          /*
        webpackChunkName:"enfoot" */ "../components/English/enfoot.vue"
        )
    },
    {
      path: "/enfoot2",
      name: "enfoot2",
      component: () =>
        import(
          /*
        webpackChunkName:"enfoot2" */ "../components/English/enfoot2.vue"
        )
    },
    {
      path: "/page2",
      name: "page2",
      component: page2
    },
    {
      path: "/canguanxuzhi",
      name: "canguanxuzhi",
      component: canguanxuzhi
    },
    {
      path: "/foot",
      name: "foot",
      component: foot
    },


    {
      path: "/",
      name: "index", component: index,


    },

    {
      path: "/gerenyuyue",
      name: "gerenyuyue",
      component: () =>
        import(
          /*
        webpackChunkName:"gerenyuyue" */ "../components/order/gerenyuyue.vue"
        )
    },
    {
      path: "/tuanduiyuyue",
      name: "tuanduiyuyue",
      component: () =>
        import(
          /*
        webpackChunkName:"tuanduiyuyue" */ "../components/order/tuanduiyuyue.vue"
        )
    },
    {
      path: "/zhengji",
      name: "zhengji",
      component: () =>
        import(
          /*
        webpackChunkName:"zhengji" */ "../components/right_nav/zhengji.vue"
        ),
      meta: {
        title: "征集"
      }
    },
    {
      path: "/zhengjiMore",
      name: "zhengjiMore",
      component: () =>
        import(
          /*
        webpackChunkName:"zhengji" */ "../components/right_nav/zhengjiMore.vue"
        ),
      // props: true,
      meta: {
        title: "征集"
      }
    },
    {
      path: "/zhengjiMoreDetail",
      name: "zhengjiMoreDetail",
      component: () =>
        import(
          /*
        webpackChunkName:"zhengji" */ "../components/right_nav/zhengjiMoreDetail.vue"
        ),
      meta: {
        title: "征集"
      }
    },
    {
      path: "/xiazaizhongxin",
      name: "xiazaizhongxin",
      component: () =>
        import(
          /*
        webpackChunkName:"zhengji" */ "../components/right_nav/xiazaizhongxin.vue"
        ),
      meta: {
        title: "征集"
      }
    },
    {
      path: "/zixunjianyi",
      name: "zixunjianyi",
      component: () =>
        import(
          /*
        webpackChunkName:"zhengji" */ "../components/right_nav/zixunjianyi.vue"
        ),
      meta: {
        title: "咨讯建议"
      }
    },
    {
      path: "/search",
      name: "search",
      component: () =>
        import(
          /*
        webpackChunkName:"search" */ "../components/search/search.vue"
        ),
      meta: {
        title: "搜索",
        keepAlive: true
      }
    },
    {
      path: "/detail_search",
      name: "detail_search",
      component: () =>
        import(
          /*
        webpackChunkName:"detail_search" */ "../components/search/detail_search.vue"
        ),
      meta: {
        title: "详情搜索"
      }
    },
    {
      path: "/regist",
      name: "regist",
      component: () =>
        import(
          /*
        webpackChunkName:"regist" */ "../components/login/regist.vue"
        )
    },
    {
      path: "/forget",
      name: "forget",
      component: () =>
        import(
          /*
        webpackChunkName:"regist" */ "../components/login/forget.vue"
        )
    },

    {
      path: "/vip",
      name: "vip",
      title: "个人中心",
      component: () =>
        import(/*
        webpackChunkName:"vip" */ "../components/vip/vip.vue")
    },
    {
      path: "/lianxiwomen",
      name: "lianxiwomen",
      component: () =>
        import(
          /*
        webpackChunkName:"vip" */ "../components/index_parent/lianxiwomen.vue"
        )
    },

    // //活动
    // {
    //   path: "/activity",
    //   name: "activity",
    //   component: () =>
    //     import(
    //       /*
    //     webpackChunkName:"activity" */ "../components/activity.vue"
    //     )
    // },
    // {
    //   path: "/huodongyugao",
    //   name: "huodongyugao",
    //   component: () =>
    //     import(
    //       /*
    //     webpackChunkName:"huodongyugao" */ "../components/activity_parent/huodongyugao.vue"
    //     ),
    //   children: [
    //     {
    //       path: "wenboketang/:id",
    //       name: "wenboketang",
    //       component: () =>
    //         import(
    //           /*
    //         webpackChunkName:"wenboketang" */ "../components/activity_parent/wenboketang.vue"
    //         )
    //     },
    //     {
    //       path: "wenboketangdetail",
    //       name: "wenboketangdetail",
    //       component: () =>
    //         import(
    //           /*
    //         webpackChunkName:"wenboketangdetail" */ "../components/activity_parent/wenboketangdetail.vue"
    //         )
    //     },
    //     {
    //       path: "huodongyugao2/:id",
    //       name: "huodongyugao2",
    //       meta: {
    //         keepAlive: true
    //       },
    //       component: () =>
    //         import(
    //           /*
    //         webpackChunkName:"huodongyugao2" */ "../components/activity_parent/huodongyugao2.vue"
    //         )
    //     },
    //     {
    //       path: "huodongyugao2detail",
    //       name: "huodongyugao2detail",
    //       component: () =>
    //         import(
    //           /*
    //         webpackChunkName:"huodongyugao2detail" */ "../components/activity_parent/huodongyugao2detail.vue"
    //         )
    //     },
    //     {
    //       path: "wenbojiangzuo/:id",
    //       name: "wenbojiangzuo",
    //       meta: {
    //         keepAlive: true
    //       },
    //       component: () =>
    //         import(
    //           /*
    //         webpackChunkName:"wenbojiangzuo" */ "../components/activity_parent/wenbojiangzuo.vue"
    //         )
    //     },
    //     {
    //       path: "wenbojiangzuodetail",
    //       name: "wenbojiangzuodetail",
    //       component: () =>
    //         import(
    //           /*
    //         webpackChunkName:"wenbojiangzuodetail" */ "../components/activity_parent/wenbojiangzuodetail.vue"
    //         )
    //     }

    //   ]
    // },
    //藏品检索
    {
      path: "/book",
      name: "book",
      component: () =>
        import(/*
        webpackChunkName:"book" */ "../components/book.vue")
    },
    {
      path: "/cangpinxinshang",
      name: "cangpinxinshang",
      component: () =>
        import(
          /*
        webpackChunkName:"cangpinxinshang" */ "../components/book_parent/cangpinxinshang.vue"
        )
    },
    {
      path: '/sanwei',
      name: 'sanwei',
      component: () => import('../components/sanwei.vue')
    },
    {
      path: "/cangpinjiansuo",
      name: "cangpinjiansuo",
      component: () =>
        import(
          /*
        webpackChunkName:"cangpinjiansuo" */ "../components/book_parent/cangpinjiansuo.vue"
        ),
      children: [
        {
          path: "cangpinjiansuo2/:id",
          name: "cangpinjiansuo2",
          component: () =>
            import(
              /*
              webpackChunkName:"cangpinjiansuo2" */ "../components/book_parent/cangpinjiansuo2.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "cangpinjiansuodetail",
          name: "cangpinjiansuodetail",
          component: () =>
            import(
              /*
              webpackChunkName:"cangpinjiansuodetail" */ "../components/book_parent/cangpinjiansuodetail.vue"
            )
        }
      ]
    },

    // 专栏-------------
    {
      path: "/column",
      name: "column",
      component: () =>
        import(
          /*
        webpackChunkName:"column" */ "../components/column.vue"
        )
    },

    {
      path: "/zhidujianshe",
      name: "zhidujianshe",
      component: () =>
        import(
          /*
        webpackChunkName:"zhidujianshe" */ "../components/column_parent/zhidujianshe.vue"
        ),
      children: [
        {
          path: "zhiyuanzhezhijia/:id?",
          component: () =>
            import(
              /*
            webpackChunkName:"zhiyuanzhezhijia" */ "../components/column_parent/zhiyuanzhezhijia.vue"
            ),
          props: true,
          meta: {
            keepAlive: false
          }
        },
        {
          path: "zhidujianshe2/:id",
          component: () =>
            import(
              /*
            webpackChunkName:"zhidujianshe2" */ "../components/column_parent/zhidujianshe2.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        },

        {
          path: "zhiyuanzhezhaomudetail",
          component: () =>
            import(
              /*
            webpackChunkName:"zhiyuanzhezhaomudetail" */ "../components/column_parent/zhiyuanzhezhaomudetail.vue"
            )
        },
        {
          path: "zhiyuanzhezhaomutable",
          component: () =>
            import(
              /*
            webpackChunkName:"zhiyuanzhezhaomutable" */ "../components/column_parent/zhiyuanzhezhaomutable.vue"
            )
        },
        {
          path: "zhiyuanzhefengcaidetail",
          component: () =>
            import(
              /*
            webpackChunkName:"zhiyuanzhefengcaidetail" */ "../components/column_parent/zhiyuanzhefengcaidetail.vue"
            )
        },
        {
          path: "zhiyuanzhefengcaitable",
          component: () =>
            import(
              /*
            webpackChunkName:"zhiyuanzhefengcaitable" */ "../components/column_parent/zhiyuanzhefengcaitable.vue"
            )
        },
        {
          path: "xuanjiaohuodongdetail",
          component: () =>
            import(
              /*
            webpackChunkName:"xuanjiaohuodongdetail" */ "../components/column_parent/xuanjiaohuodongdetail.vue"
            )
        },
        {
          path: "zhidujianshe2detail",
          component: () =>
            import(
              /*
            webpackChunkName:"zhiyuanzhezhijiadetail" */ "../components/column_parent/zhidujianshe2detail.vue"
            )
        },
        {
          path: "jxshzyhxjzgdetail",
          component: () =>
            import(
              /*
            webpackChunkName:"jxshzyhxjzgdetail" */ "../components/column_parent/jxshzyhxjzgdetail.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        }
      ]
    },
    {
      path: "/consult",
      name: "consult",
      component: () =>
        import(
          /*
        webpackChunkName:"consult_z" */ "../components/consult.vue"
        )
    },


    //咨询
    {
      path: "/yellow/:id",
      name: "yellow",
      component: yellow,
      props: true
    },

    {
      path: "/wenchuang",
      component: () =>
        import(
          /*
      webpackChunkName:"lindaojieshao" */ "../components/wenchuang/wenchuang.vue"
        )
    },
    {
      path: "/guanwugongkai",
      name: "guanwugongkai",
      component: () =>
        import(
          /*
        webpackChunkName:"guanwugongkai" */ "../components/consult_parent/guanwugongkai.vue"
        ),
      children: [

        {
          path: "guanwugongkai2/:id",
          name: "guanwugongkai2",
          component: () =>
            import(
              /*
            webpackChunkName:"guanwugongkai2" */ "../components/consult_parent/guanwugongkai2.vue"
            ),
          props: true,
          meta: {
            // keepAlive: true
          }
        },

        {
          path: "guanwugongkai2detail",
          name: "guanwugongkai2detail",

          component: () =>
            import(
              /*
            webpackChunkName:"guanwugongkai2detail" */ "../components/consult_parent/guanwugongkai2detail.vue"
            )
        },
        {
          path: "wenbodongtai/:id",
          name: "wenbodongtai",
          component: () =>
            import(
              /*
            webpackChunkName:"guanwugongkai2" */ "../components/consult_parent/wenbodongtai.vue"
            ),
          props: true,
          meta: {
            // keepAlive: true
          }
        },
        {
          path: "wenbodongtaidetail",
          name: "wenbodongtaidetail",

          component: () =>
            import(
              /*
            webpackChunkName:"wenbodongtaidetail" */ "../components/consult_parent/wenbodongtaidetail.vue"
            )
        },
        {
          path: "dashiji/:id",
          name: "dashiji",
          meta: {
            keepAlive: true
          },
          component: () =>
            import(
              /*
            webpackChunkName:"dashiji" */ "../components/consult_parent/dashiji.vue"
            )
        },
        {
          path: "dashijidetail",
          name: "dashijidetail",

          component: () =>
            import(
              /*
            webpackChunkName:"wenbodongtaidetail" */ "../components/consult_parent/dashijidetail.vue"
            )
        }
      ]
    },
    //展览
    {
      path: "/show",
      name: "show",
      component: () =>
        import(/*
        webpackChunkName:"show" */ "../components/show.vue")
    },
    {
      path: "/quanjing",
      name: "quanjing",
      component: () =>
        import(
          /*
        webpackChunkName:"quanjing" */ "../components/show_parent/quanjing.vue"
        ),
      meta: {
        title: "全景"
      }
    },
    {
      path: "/linzhan",
      // redirect:'linzhan2',
      component: () =>
        import(
          /*
        webpackChunkName:"linzhan" */ "../components/show_parent/linzhan.vue"
        ),

      children: [
        {
          path: "basez/:id",
          name: "basez",
          component: () =>
            import(
              /*
            webpackChunkName:"basez" */ "../components/show_parent/basez.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "parent",
          component: () =>
            import(
              /*
            webpackChunkName:"parent" */ "../components/show_parent/parent.vue"
            )
        },
        {
          path: "line",
          name: "line",
          // redirect:'line',
          component: () =>
            import(
              /*
            webpackChunkName:"linzhan2" */ "../components/show_parent/line.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          },
          redirect: {
            name: "year1"
          },
          children: [
            {
              path: "year1/:id",
              name: "year1",
              component: () =>
                import(
                  /*
                  webpackChunkName:"line" */ "../components/show_parent/linzhan2_parent/year1.vue"
                ),
              props: true
            },

            {
              path: "year1detail",
              name: "year1detail",
              component: () =>
                import(
                  /*
                  webpackChunkName:"line" */ "../components/show_parent/linzhan2_parent/year1detail.vue"
                ),
              props: true
            }
          ]
        },
        {
          path: "year/:id",
          name: "year",
          component: () =>
            import(
              /*
            webpackChunkName:"year" */ "../components/show_parent/year.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "linzhan2detail",
          component: () =>
            import(
              /*
            webpackChunkName:"linzhan2detail" */ "../components/show_parent/linzhan2detail.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "yeardetail",
          component: () =>
            import(
              /*
            webpackChunkName:"yeardetail" */ "../components/show_parent/yeardetail.vue"
            )
        },
        {
          path: "basezdetail",
          component: () =>
            import(
              /*
            webpackChunkName:"basezdetail" */ "../components/show_parent/basezdetail.vue"
            )
        },
        // {
        //   path: "xuni",
        //   component: () =>
        //     import(
        //       /*
        //     webpackChunkName:"xuni" */ "../components/show_parent/xuni.vue"
        //     )
        // }
      ]
    },

    {
      path: "/summaryz",
      name: "summaryz",
      component: () =>
        import(
          /*
        webpackChunkName:"summaryz" */ "../components/summaryz.vue"
        )
    },
    //xueshu------------
    {
      path: "/learning",
      name: "learning",
      component: () =>
        import(
          /*
        webpackChunkName:"learning" */ "../components/learning.vue"
        )
    },

    // ----
    {
      path: "/ketiyanjiu",
      name: "ketiyanjiu",
      component: () =>
        import(
          /*
        webpackChunkName:"ketiyanjiu" */ "../components/learning_parent/ketiyanjiu.vue"
        ),
      children: [

        {
          path: "ketiyanjiu2/:id",
          component: () =>
            import(
              /*
            webpackChunkName:"ketiyanjiu2" */ "../components/learning_parent/ketiyanjiu2.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "ketiyanjiu2detail",
          component: () =>
            import(
              /*
            webpackChunkName:"ketiyanjiu2detail" */ "../components/learning_parent/ketiyanjiu2detail.vue"
            )
        }

      ]
    },
    // 新增菜单项
    {
      path: "/newmenu",
      name: "newmenu",
      component: () =>
        import(
          /*
        webpackChunkName:"newmenu" */ "../components/learning_parent/newmenu1.vue"
        ),
      children: [

        {
          path: "newmenu1",
          component: () =>
            import(
              /*
            webpackChunkName:"ketiyanjiu2" */ "../components/learning_parent/newmenu01.vue"
            ),
          props: true,
          meta: {
            keepAlive: true
          }
        },
        {
          path: "newmenudetail",
          component: () =>
            import(
              /*
            webpackChunkName:"ketiyanjiu2detail" */ "../components/learning_parent/newmenudetail.vue"
            )
        }

      ]
    },


    {
      path: "/lindaojieshao",
      component: () =>
        import(
          /*
        webpackChunkName:"lindaojieshao" */ "../components/summary_parent/lindaojieshao.vue"
        ),
      children: [
        {
          path: "lindaojieshao2/:id",
          component: () =>
            import(
              /*
            webpackChunkName:"lindaojieshao2" */ "../components/summary_parent/lindaojieshao2.vue"
            ),
          props: true,
          meta: {
            keepAlive: false
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js